import type { GetOrganizationWithModulesDto } from '@app/services/rtkQuery/types';
import type { AccessRightsModules } from '@app/types/NewAccessRight';

const modules: Record<string, string> = {
  Leads: '1',
  Integrations: '2',
  CrmTasks: '3',
  Records: '4',
  SalesFunnels: '5',
  WhatsAppIntegrations: '6',
  Sendouts: '7',
  AiOperator: '8',
  Warehouse: '9',
};

export const checkAllowedModule = (
  key: keyof AccessRightsModules,
  modulesAccess?: GetOrganizationWithModulesDto['Modules']
) => {
  if (!modulesAccess) return false;

  const mapKey = typeof key === 'string' ? key : String(key);

  const module = modules[mapKey];

  const finded = modulesAccess.find((m) => String(m.RightType) === module);

  return finded ? Boolean(finded.Allowed) : true;
};
